import src from "IMAGE";
export default { src, width: 2880, height: 2000, blurWidth: 8, blurHeight: 6, blurDataURL: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAGCAYAAAD+Bd/7AAAAR0lEQVR42nWOQQrAMAgEl9TENv3/f6tlAhLIYVAcVpUkD1pw0Y+gwyNkQ3iRN/yyH2T2MtIGjszZ1CZHSeb9VzxnZfWqmZ4fZkcBIFxWsqsAAAAASUVORK5CYII="};
